import Multiselect from 'multiselect-react-dropdown';
import React from 'react';
import { FormControl, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';

import './SmartDocMappingRow.css';

const FormInput = React.lazy(() => import('../../components/FormInput/FormInput'));
const SkeletonBar = () => <div className="smart-docs-mapping-skeleton" />;

const SmartDocMappingRow = React.memo(function DocumentRow({
    row,
    index,
    destinationDocumentOptions,
    isDestinationDocsLoading,
    isBusy,
    destinationInstanceId,
    onUpdate,
}) {
    const selectedDestValues = React.useMemo(
        () => destinationDocumentOptions.filter((doc) => doc.id === row.destinationDocumentId),
        [destinationDocumentOptions, row.destinationDocumentId]
    );

    const handleDestSelect = React.useCallback(
        (list, item) => onUpdate(index, 'destinationDocumentId', item.id),
        [index, onUpdate]
    );
    const handleDestRemove = React.useCallback(
        () => onUpdate(index, 'destinationDocumentId', ''),
        [index, onUpdate]
    );
    const handleCopyPdf = React.useCallback(
        (id, value) => onUpdate(index, 'copyPdf', value),
        [index, onUpdate]
    );
    const handleCopyMapping = React.useCallback(
        (id, value) => onUpdate(index, 'copyMapping', value),
        [index, onUpdate]
    );

    return (
        <Row className="smart-docs-mapping-grid-row">
            <div className="col-md-4">
                <FormControl type="text" value={row.sourceDocumentName} readOnly disabled={isBusy} />
            </div>
            <div className="col-md-4">
                {isDestinationDocsLoading ? (
                    <SkeletonBar />
                ) : (
                    <Multiselect
                        showArrow={true}
                        options={destinationDocumentOptions}
                        selectionLimit={1}
                        displayValue="name"
                        disable={isBusy}
                        placeholder="Select Document..."
                        emptyRecordMsg={destinationInstanceId ? "No Documents Available" : "Please select a destination instance."}
                        className="smart-docs-mapping"
                        closeOnSelect={true}
                        selectedValues={selectedDestValues}
                        onSelect={handleDestSelect}
                        onRemove={handleDestRemove}
                    />
                )}
            </div>
            <div className="col-md-2 smart-docs-mapping-checkbox-cell">
                <FormInput
                    type="checkbox"
                    id={`${row.sourceDocumentId}_${index}_copyPdf`}
                    value={row.copyPdf}
                    disabled={isBusy}
                    changed={handleCopyPdf}
                />
            </div>
            <div className="col-md-2 smart-docs-mapping-checkbox-cell">
                <OverlayTrigger
                    placement="top"
                    trigger={!row.destinationDocumentId && !row.copyPdf ? ['hover', 'focus'] : []}
                    overlay={
                        <Tooltip id="copy-mapping-tooltip">
                            Please select a destination document or enable Copy PDF.
                        </Tooltip>
                    }
                >
                    <span
                        style={{ display: 'inline-block' }} // span around a disabled input still needs this to catch hover
                        tabIndex={-1}
                    >
                        <FormInput
                            type="checkbox"
                            id={`${row.sourceDocumentId}_${index}_copyMapping`}
                            value={row.copyMapping}
                            disabled={isBusy || (!row.destinationDocumentId && !row.copyPdf)}
                            changed={handleCopyMapping}
                        />
                    </span>
                </OverlayTrigger>
            </div>
        </Row>
    );
});

export default SmartDocMappingRow;